const FacebookIcon = ({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 19) / 18}
        viewBox='0 0 18 19'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M7.43101 18.334H10.9173V10.2895H13.4925L14.0075 7.03985H10.9173V4.58272C10.9173 3.67139 11.7892 3.15631 12.6207 3.15631H14.1262V0.461549L11.4328 0.342729C8.85758 0.184113 7.43158 2.20519 7.43158 4.62252V7.03985H4.5V10.2895H7.43158V18.334H7.43101Z'
        />
      </svg>
    </span>
  );
};

export default FacebookIcon;
